var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTranslateIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H20C22.2091 0 24 1.79086 24 4V20C24 22.2091 22.2091 24 20 24H4C1.79086 24 0 22.2091 0 20V4Z",
    fill: "#FFC1C1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.973 19L15.986 9.88393L19 19M13.983 15.9438H17.976M5 6.57252H15.516M10.258 5V6.44604M8.32 8.91535C8.91595 9.94349 9.57775 10.9201 10.3 11.8371M10.3 11.8371C10.8948 12.5932 11.5293 13.3074 12.2 13.9759M10.3 11.8371C9.23448 13.3834 8.01083 14.7793 6.655 15.9951M10.3 11.8371C11.414 10.2209 12.3463 8.45237 13.075 6.57252",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTranslateIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/translate-icon.df0ca209afda7296f2743b1f21797c5c.svg";